import { redirect, RouteObject } from 'react-router-dom';
import { UserPermissions } from '../../components/restricted';
import { fromRestrictedRouteObjects } from '../../components/restricted/routing';

import RekvisitionScreen from './rekvisition-screen';
import SeeRekvisitionScreen from './see-rekvisition-screen';
import RekvisitionUpdateScreen from './rekvisition-update-screen';
import Http404 from '../http/404';
import Api from '../../shared/networking/api';
import useCTNavigate from '../../shared/hooks/use-ct-navigate';
import { useEffect } from 'react';

const RekvisitionRouterObjects: RouteObject[] = fromRestrictedRouteObjects([
    {
        index: true,
        element: <RekvisitionScreen />,
        permissions: UserPermissions.Rekvisition,
    },
    {
        path: 'Create',
        loader: async ({ params: { id } }) => {
            // Redirect to /MissingEnhed is id is missing. This works around the loader triggering before the id check is rendered
            const nId = Number(id);
            if (isNaN(nId) || nId <= 0) {
                return redirect('/Rekvisition/Create/MissingEnhed');
            }
            const response = await Api.post<{ id: number }[]>(`/Finans/rekvisition?enhedsys=${id}`);
            if (!Api.ok(response)) {
                return redirect(`/${id}/Rekvisition?error=Kunne ikke oprette ny rekvisition`);
            };
            return redirect(`/${id}/Rekvisition/${response.data[0].id}/update`);
        }
    },
    {
        path: 'Create/MissingEnhed',
        element: (() => {
            // Give time for the user to select Enhed before redirecting
            const Redirector = () => {
                const navigate = useCTNavigate();
                useEffect(() => {
                    navigate('/Rekvisition/Create');
                });
                return <></>;
            }
            return <Redirector />;
        })()
    },
    {
        path: ':rekvisitionId',
        element: <SeeRekvisitionScreen />,
        permissions: UserPermissions.Rekvisition,
    },
    {
        path: ':rekvisitionId/update',
        element: <RekvisitionUpdateScreen />,
        permissions: UserPermissions.Rekvisition_Update_Fields,
    },
    {
        path: '*',
        element: <Http404 />,
    },
]);

export default RekvisitionRouterObjects;
